module["exports"] = [
  "090-####-####",
  "080-####-####",
  "070-####-####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ja/cell_phone/formats.js
// module id = 1434
// module chunks = 0